module.exports = __webpack_public_path__ + "static/strip2 - Copy-3df4ba075284b3d86c2435796101d15b.jpg";